// Which model answers in this conversation (plan
// brain-conversacion-en-segundo-plano, D9, 7.2). By default, the agent's; the
// list is the catalog's models that have a key. Choosing one does not change
// the agent: it is this conversation's choice.

import { useTranslation } from 'react-i18next'
import { Check, ChevronDown, Cpu } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { ChosenModel } from '@/services/brainApi'
import type { AgentAvailableModel } from '@/types/agent'

const isThisOne = (model: AgentAvailableModel, chosen: ChosenModel | null) =>
  Boolean(chosen && chosen.provider === model.provider && chosen.model === model.model)

export function ModelSelector({
  models,
  chosen,
  onChoose,
  disabled,
}: {
  models: AgentAvailableModel[]
  chosen: ChosenModel | null
  onChoose: (model: ChosenModel | null) => void
  disabled?: boolean
}) {
  const { t } = useTranslation()
  const current = models.find((model) => isThisOne(model, chosen))

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="xs"
          disabled={disabled}
          aria-label={t('brain.modelo.elegir')}
          className="gap-1 text-muted-foreground hover:text-foreground"
        >
          <Cpu className="h-3.5 w-3.5" />
          <span className="max-w-32 truncate text-xs">{current?.label ?? t('brain.modelo.del_agente')}</span>
          <ChevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuItem onSelect={() => onChoose(null)} className="justify-between">
          {t('brain.modelo.del_agente')}
          {!current && <Check className="h-4 w-4" />}
        </DropdownMenuItem>
        {models.length > 0 && <DropdownMenuSeparator />}
        {models.map((model) => (
          <DropdownMenuItem
            key={model.id}
            onSelect={() => onChoose({ provider: model.provider, model: model.model })}
            className="justify-between"
          >
            <span className="truncate">{model.label}</span>
            {isThisOne(model, chosen) && <Check className="h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
